<template>

</template>

<script>
    export default {
        props:{
            showMessage: {
                type: Boolean,
                default: true
            },
            confirmUrl: {
                type: String,
                required: true
            }
        },
        methods: {
            getText() {
                return '<div style="text-align: left;">' +
                    'Vážený uživateli,<br>' +
                    '<br>' +
                    'vstupujete do databázového úložiště zřízeného skupinou Kreston A&CE. Informace a materiály, které jsou obsahem tohoto úložiště, jsou důvěrné povahy a jsou určeny výhradě pro uživatele - zaměstnance skupiny Kreston A&CE, kteří jsou povinni tyto informace a materiály používat výhradě v rámci plnění svých pracovních povinností. Jakékoliv další využití, šíření či jakákoliv jiná forma, byť i bezplatná,   distribuce těchto informací a materiálů je zakázána. Porušením tohoto zákazu se zaměstnanec dopouští jednání, které je v rozporu s oprávněnými zájmy zaměstnavatele ve smyslu ust. § 301 Zákoníku práce.<br>' +
                    '<br>' +
                    'Výše uvedenému poučení jsem porozuměl a zavazuji se jednat v souladu s tímto.<br>' +
                    '</div>';
            },
            confirmPopup() {
                axios({
                    method: 'POST',
                    url: this.confirmUrl
                });
            }
        },

        mounted() {
            if (this.showMessage) {
                swal({
                    html: this.getText(),
                    showCancelButton: false,
                    confirmButtonText: 'Rozumím',
                    width: '800px'
                }).then(result => {
                    if (result.value && result.value === true) {
                        this.confirmPopup();
                    }
                })
            }
        }
    }
</script>
